import { Injectable } from '@angular/core';
import { FolderInterface } from 'app/models/folder.model';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';

@Injectable({
  providedIn: 'root',
})
export class FolderDataTransformGet extends DataTransformAbstractGet {
  transform(folder: FolderInterface): FolderInterface {
    console.log('FolderDataTransformGet transform', folder);
    return folder;
  }
}
